import React from "react";
import { Provider } from "react-redux";
import { store } from "../components/whatsapp/twilio-react/store/index.ts";
import { Theme } from "@twilio-paste/core/theme";
//export const WhatsAppContext = React.createContext({})

export function WhatsAppProvider(props) {
   // const [token,setToken] = React.useState(null)
  //  const clientRef = useRef(null)
    // const getToken = async () => {
    //     const result = await API.post("sussdAdminAPI", "/operations/messaging/get-whatsapp-token", {
    //         body: {
    //             email: 'kevin@sussd.ie',
    //         }
    //     })
    //     console.log({RESULTTOKEN: result})
    //     if (result){
    //         setToken(result)
    //     }
    // }

    // useEffect(() => {
    //     getToken().catch(() => {
    //         throw new Error("Unable to get token, please reload this page")
    //     })
    // }, [])

    // useEffect(() => {
    //     if (token && !clientRef.current) {
    //         const client = new Client(token)
    //         clientRef.current = client
    //
    //         client.on("initialized", () => {
    //             console.log("Twilio Conversations client initialized")
    //             loadConversations()
    //         })
    //
    //         client.on("initFailed", ({ error }) => {
    //             console.error("Twilio client init failed", error)
    //         })
    //     }
    // }, [token])
    // if (!token) {
    //     return null
    // }
    return (
         // <WhatsAppContext.Provider value={{  token }}>
            <Provider store={store}>
                <Theme.Provider theme="twilio">
                    {props.children}
                </Theme.Provider>
            </Provider>
         // </WhatsAppContext.Provider>
    )
}

// export const useWhatsAppToken = () => {
//     const context = React.useContext(WhatsAppContext)
//     if (!context) {
//         throw new Error("useWhatsAppToken must be used within a WhatsAppProvider")
//     }
//     return context ?? { token: null };
// }